import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-dropzone-uploader/dist/styles.css';
import Root from './Root';
import './styles/index.less';
import configStore from './common/store';
import routeConfig from './common/routeConfig';

const store = configStore();
ReactDOM.render(<Root store={store} routeConfig={routeConfig} />, document.getElementById('root'));
